module.exports = __webpack_public_path__ + "img/Wp_2007.c63f6793.png";